import { render, staticRenderFns } from "./ExactAuthorizationDialog.vue?vue&type=template&id=618bee79"
import script from "./ExactAuthorizationDialog.vue?vue&type=script&lang=ts"
export * from "./ExactAuthorizationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports